export default {
  "branchen": [
    {
      "code": "0000",
      "shortname": "Sonstiges",
      "name": "Sonstige Branche"
    },
    {
      "code": "0001",
      "shortname": "Altenheime",
      "name": "Altenheime"
    },
    {
      "code": "0002",
      "shortname": "Amb.  Pflege",
      "name": "Ambulante Alten-/Krankenpflege"
    },
    {
      "code": "0003",
      "shortname": "Immobilienmakl.",
      "name": "An- u. Verkauf von Immobilien"
    },
    {
      "code": "0004",
      "shortname": "Apotheken",
      "name": "Apotheken"
    },
    {
      "code": "0005",
      "shortname": "Arbeitn.Überl.",
      "name": "Arbeitnehmerüberlassung"
    },
    {
      "code": "0006",
      "shortname": "Architekturbüro",
      "name": "Architekturbüro"
    },
    {
      "code": "0007",
      "shortname": "Arzneimittelh.",
      "name": "Arzneimittelherstellung"
    },
    {
      "code": "0008",
      "shortname": "Arztpraxis",
      "name": "Ärzte, Arztpraxen, Heilberufe"
    },
    {
      "code": "0009",
      "shortname": "Asbestbearb.",
      "name": "Asbestbe-/verarbeitung"
    },
    {
      "code": "0010",
      "shortname": "Autohäuser",
      "name": "Autohäuser"
    },
    {
      "code": "0011",
      "shortname": "Autolackierer",
      "name": "Autolackierer"
    },
    {
      "code": "0012",
      "shortname": "Bäckerei",
      "name": "Bäckerei"
    },
    {
      "code": "0013",
      "shortname": "Banken/Spark. ",
      "name": "Banken, Sparkassen u.ä."
    },
    {
      "code": "0014",
      "shortname": "Bar/Bistro",
      "name": "Bar/Bistro"
    },
    {
      "code": "0015",
      "shortname": "Baugewerbe",
      "name": "Baugewerbe"
    },
    {
      "code": "0016",
      "shortname": "Baustoffherst.",
      "name": "Baustoffherstellung"
    },
    {
      "code": "0017",
      "shortname": "Bekleidungsher.",
      "name": "Bekleidungsherstellung"
    },
    {
      "code": "0018",
      "shortname": "Sozialbetreuung",
      "name": "Betreuung v. Kindern a. Problemfamilien"
    },
    {
      "code": "0019",
      "shortname": "Bewachungsun.",
      "name": "Bewachungsunternehmen"
    },
    {
      "code": "0020",
      "shortname": "Biogasanlagen",
      "name": "Biogasanlagen"
    },
    {
      "code": "0021",
      "shortname": "Schiffbau",
      "name": "Boots- und Schiffsbau"
    },
    {
      "code": "0022",
      "shortname": "Brauerei",
      "name": "Brauerei / Mälzerei"
    },
    {
      "code": "0023",
      "shortname": "Brennerei",
      "name": "Brennerei"
    },
    {
      "code": "0024",
      "shortname": "Bäckerei",
      "name": "Brot- und Backwarenherstellung"
    },
    {
      "code": "0025",
      "shortname": "Buchhandlung",
      "name": "Buchhandlung"
    },
    {
      "code": "0026",
      "shortname": "Busunternehmen",
      "name": "Busunternehmen"
    },
    {
      "code": "0027",
      "shortname": "Casinos",
      "name": "Casinos"
    },
    {
      "code": "0028",
      "shortname": "Chem. Reinigung",
      "name": "Chemische Reinigung"
    },
    {
      "code": "0029",
      "shortname": "Containerunt.",
      "name": "Containerunternehmen"
    },
    {
      "code": "0030",
      "shortname": "Dachdeckerei",
      "name": "Dachdeckerei"
    },
    {
      "code": "0031",
      "shortname": "Datenverarbb",
      "name": "Datenverarbeitung/App-Entwicklung"
    },
    {
      "code": "0032",
      "shortname": "Detekteien",
      "name": "Detekteien"
    },
    {
      "code": "0168",
      "shortname": "Dialysezentren",
      "name": "Dialysezentren"
    },
    {
      "code": "0033",
      "shortname": "Diskotheken",
      "name": "Diskotheken"
    },
    {
      "code": "0034",
      "shortname": "Drogerie",
      "name": "Drogerie"
    },
    {
      "code": "0035",
      "shortname": "Druckerei",
      "name": "Druckerei"
    },
    {
      "code": "0036",
      "shortname": "Elektrogeräteh.",
      "name": "Elektrogeräteherstellung"
    },
    {
      "code": "0037",
      "shortname": "Elektroinst.",
      "name": "Elektroinstallation"
    },
    {
      "code": "0038",
      "shortname": "Elektronikher.",
      "name": "Elektronikprodukteherstellung"
    },
    {
      "code": "0039",
      "shortname": "Energievers.",
      "name": "Energieversorgung  + artverwandte Firmen"
    },
    {
      "code": "0040",
      "shortname": "Entsorgungsunt.",
      "name": "Entsorgungsunternehmen"
    },
    {
      "code": "0041",
      "shortname": "Escape-Room",
      "name": "Escape-Room"
    },
    {
      "code": "0042",
      "shortname": "Fahrschulen",
      "name": "Fahrschulen"
    },
    {
      "code": "0043",
      "shortname": "Fahrzeugbau",
      "name": "Fahrzeugbau"
    },
    {
      "code": "0044",
      "shortname": "Fensterbau",
      "name": "Fenster- / Türenbau und -montage"
    },
    {
      "code": "0045",
      "shortname": "Filmproduktion",
      "name": "Filmproduktionsfirmen"
    },
    {
      "code": "0046",
      "shortname": "Fischzucht",
      "name": "Fischerei / Fischzucht"
    },
    {
      "code": "0047",
      "shortname": "Wurstwarenherst",
      "name": "Fleisch- und Wurstwarenherstellung"
    },
    {
      "code": "0048",
      "shortname": "Fleischerei",
      "name": "Fleischerei / Metzgerei / Schlachterei"
    },
    {
      "code": "0049",
      "shortname": "Fliesenleger",
      "name": "Fliesen- und Plattenlegebetrieb"
    },
    {
      "code": "0050",
      "shortname": "Fondsges.",
      "name": "Fondsgesellschaft"
    },
    {
      "code": "0051",
      "shortname": "Fondsmakler",
      "name": "Fondsmakler"
    },
    {
      "code": "0052",
      "shortname": "Fotolabor",
      "name": "Fotolabor"
    },
    {
      "code": "0053",
      "shortname": "Fuhrunternehmen",
      "name": "Fuhrunternehmen"
    },
    {
      "code": "0054",
      "shortname": "Gartenbau",
      "name": "Gärtnerei / Garten- und Landschaftsbau"
    },
    {
      "code": "0055",
      "shortname": "Gaststätte",
      "name": "Gaststättenbetrieb"
    },
    {
      "code": "0056",
      "shortname": "Gebäudereinig.",
      "name": "Gebäudereinigungsunternehmen"
    },
    {
      "code": "0057",
      "shortname": "Gerüstbau",
      "name": "Gerüstbau"
    },
    {
      "code": "0058",
      "shortname": "Getränkeherst.",
      "name": "Getränkeherstellung"
    },
    {
      "code": "0059",
      "shortname": "Stukkateur",
      "name": "Gipserei, Verputzerei, Stukkateurbetrieb"
    },
    {
      "code": "0060",
      "shortname": "Glaserei",
      "name": "Glaserei"
    },
    {
      "code": "0061",
      "shortname": "Glaubensgem.",
      "name": "Glaubensgemeinschaften"
    },
    {
      "code": "0062",
      "shortname": "Handel(NonFood)",
      "name": "Groß- und Einzelhandel (Non-Food)"
    },
    {
      "code": "0063",
      "shortname": "Groß-/ Einzelh.",
      "name": "Groß- und Einzelhandel mit Nahrungs- und Genussmitteln"
    },
    {
      "code": "0064",
      "shortname": "Großküche",
      "name": "Großküche"
    },
    {
      "code": "0065",
      "shortname": "Handelsvertr.",
      "name": "Handelsvertreter"
    },
    {
      "code": "0066",
      "shortname": "Hard-u. Softw.",
      "name": "Hard- und Softwareherstellung"
    },
    {
      "code": "0067",
      "shortname": "Haustechnik",
      "name": "Haustechnik"
    },
    {
      "code": "0068",
      "shortname": "Heiler",
      "name": "Heiler"
    },
    {
      "code": "0069",
      "shortname": "Heizölhandel",
      "name": "Heizölhandel"
    },
    {
      "code": "0070",
      "shortname": "Hoch- u.Tiefbau",
      "name": "Hoch- und Tiefbau"
    },
    {
      "code": "0071",
      "shortname": "Holzverareitung",
      "name": "Holzbe- und -verarbeitung"
    },
    {
      "code": "0072",
      "shortname": "Hotelbetrieb",
      "name": "Hotelbetrieb"
    },
    {
      "code": "9004",
      "shortname": "Hotelkette",
      "name": "Hotelkette"
    },
    {
      "code": "0073",
      "shortname": "Ingenieurbüro",
      "name": "Ingenieurbüro"
    },
    {
      "code": "0074",
      "shortname": "Insolvenzverw.",
      "name": "Insolvenzverwalter"
    },
    {
      "code": "9001",
      "shortname": "Internethandel",
      "name": "Internethandel"
    },
    {
      "code": "0075",
      "shortname": "Heizungsbau",
      "name": "Installation von Heizungs-, Lüftungs-, Klimaanlagen"
    },
    {
      "code": "0076",
      "shortname": "Kantinenbetrieb",
      "name": "Kantinenbetrieb"
    },
    {
      "code": "0077",
      "shortname": "Kapitalanlageg.",
      "name": "Kapitalanlagegesellschaften"
    },
    {
      "code": "0078",
      "shortname": "Karosseriebau",
      "name": "Karosseriebau"
    },
    {
      "code": "0079",
      "shortname": "Keramikherst.",
      "name": "Keramikherstellung und- verarbeitung"
    },
    {
      "code": "0080",
      "shortname": "KFZ-Handel",
      "name": "KFZ-Handel"
    },
    {
      "code": "0081",
      "shortname": "Kfz-Reparatur",
      "name": "Kfz-Instandhaltung- und Reparatur"
    },
    {
      "code": "0082",
      "shortname": "Kfz-Zubehörher.",
      "name": "Kfz-Zubehörherstellung"
    },
    {
      "code": "0083",
      "shortname": "Kinderheime",
      "name": "Kinderheime"
    },
    {
      "code": "0084",
      "shortname": "Kino",
      "name": "Kino"
    },
    {
      "code": "0085",
      "shortname": "Kirchen",
      "name": "Kirchen"
    },
    {
      "code": "0086",
      "shortname": "Klärwerke",
      "name": "Klärwerke"
    },
    {
      "code": "0087",
      "shortname": "Klempner",
      "name": "Klempnerei, Gas- und Wasserinstallation"
    },
    {
      "code": "0088",
      "shortname": "Kommunen",
      "name": "Kommunen"
    },
    {
      "code": "0089",
      "shortname": "Konditorei",
      "name": "Konditorei"
    },
    {
      "code": "0090",
      "shortname": "Kraftwertk",
      "name": "Kraftwerke (z.B. Biogas, Wasser, Wind)"
    },
    {
      "code": "0091",
      "shortname": "Krankenhäuser",
      "name": "Krankenhäuser"
    },
    {
      "code": "0092",
      "shortname": "Kunststoffherst",
      "name": "Kunststoffherstellung und -verarbeitung"
    },
    {
      "code": "0093",
      "shortname": "Kurierbetriebe",
      "name": "Kurierbetriebe"
    },
    {
      "code": "0094",
      "shortname": "Lackiererei",
      "name": "Lackiererei"
    },
    {
      "code": "0095",
      "shortname": "Lagereibetrieb",
      "name": "Lagereibetrieb"
    },
    {
      "code": "0096",
      "shortname": "Lederherst",
      "name": "Lederherstellung- und verarbeitung"
    },
    {
      "code": "0097",
      "shortname": "Lohnsteuerhilfe",
      "name": "Lohnsteuerhilfevereine"
    },
    {
      "code": "0098",
      "shortname": "Malerbetrieb",
      "name": "Maler- und Tapezierbetrieb"
    },
    {
      "code": "0099",
      "shortname": "Maschinenbau",
      "name": "Maschinenbau"
    },
    {
      "code": "0100",
      "shortname": "Med. Geräteher.",
      "name": "Medizinische Geräteherstellung"
    },
    {
      "code": "0101",
      "shortname": "Metallherst.",
      "name": "Metallherstellung, -be / und -verarbeitung"
    },
    {
      "code": "0102",
      "shortname": "Autovermietung",
      "name": "Mietwagenunternehmen/Autovermietung"
    },
    {
      "code": "0103",
      "shortname": "Mineralölvertr.",
      "name": "Mineralölvertrieb"
    },
    {
      "code": "0104",
      "shortname": "Möbelherst.",
      "name": "Möbelherstellung"
    },
    {
      "code": "0105",
      "shortname": "Mülldeponie",
      "name": "Mülldeponie"
    },
    {
      "code": "0106",
      "shortname": "Müllverwertung",
      "name": "Müllverwertung"
    },
    {
      "code": "0107",
      "shortname": "Nachtclub",
      "name": "Nachtclubs und Kabarett"
    },
    {
      "code": "0108",
      "shortname": "Nahrungsmittel",
      "name": "Nahrungs- und Genussmittelherstellung"
    },
    {
      "code": "0109",
      "shortname": "Notare",
      "name": "Notare"
    },
    {
      "code": "0110",
      "shortname": "Eventagentur",
      "name": "Organisation von Massenveranstaltungen"
    },
    {
      "code": "0111",
      "shortname": "Paketdienst",
      "name": "Paketdienst"
    },
    {
      "code": "0112",
      "shortname": "Papierherst.",
      "name": "Papierherstellung und -verarbeitung"
    },
    {
      "code": "0113",
      "shortname": "Parteien",
      "name": "Parteien/politische Vereinigungen"
    },
    {
      "code": "0114",
      "shortname": "Permanentkosm.",
      "name": "Permanentkosmetiker"
    },
    {
      "code": "0115",
      "shortname": "Personalleasing",
      "name": "Personalleasing"
    },
    {
      "code": "0116",
      "shortname": "Personenschutz",
      "name": "Personenschutz"
    },
    {
      "code": "0117",
      "shortname": "stat. Pfleged.",
      "name": "Pflegedienste stationär"
    },
    {
      "code": "0118",
      "shortname": "Porzellanherst.",
      "name": "Porzellanherstellung und -verarbeitung"
    },
    {
      "code": "0119",
      "shortname": "Pyrotech.–Prod.",
      "name": "Pyrotechnik–Produktion"
    },
    {
      "code": "0120",
      "shortname": "Pyrotech.Veran.",
      "name": "Pyrotechnik–Veranstalter"
    },
    {
      "code": "0121",
      "shortname": "Raumausstattung",
      "name": "Raumausstattung"
    },
    {
      "code": "0122",
      "shortname": "Rechtsanwälte",
      "name": "Rechtsanwälte"
    },
    {
      "code": "0123",
      "shortname": "Recycling",
      "name": "Recyclingunternehmen"
    },
    {
      "code": "0124",
      "shortname": "Glaubensgem.",
      "name": "religiöse Gemeinschaften"
    },
    {
      "code": "0125",
      "shortname": "Schamanen",
      "name": "Schamanen"
    },
    {
      "code": "0126",
      "shortname": "Schausteller",
      "name": "Schausteller"
    },
    {
      "code": "0127",
      "shortname": "Schiffscont.",
      "name": "Schiffscontainer - Handel/Vermietung"
    },
    {
      "code": "0128",
      "shortname": "Schließges.",
      "name": "Schließgesellschaften"
    },
    {
      "code": "0129",
      "shortname": "Schlüsseldienst",
      "name": "Schlüsseldienst"
    },
    {
      "code": "0130",
      "shortname": "Schrotthandel",
      "name": "Schrotthandel, -verwertung"
    },
    {
      "code": "0131",
      "shortname": "Schuhherst.",
      "name": "Schuhherstellung"
    },
    {
      "code": "0132",
      "shortname": "Security-Untern",
      "name": "Security-Unternehmen"
    },
    {
      "code": "0133",
      "shortname": "Speditionen",
      "name": "Speditionen"
    },
    {
      "code": "0134",
      "shortname": "Spielhalle",
      "name": "Spielhalle, Spielsalon"
    },
    {
      "code": "0135",
      "shortname": "Spielwarenherst",
      "name": "Spielwarenherstellung"
    },
    {
      "code": "0136",
      "shortname": "Spirituosenher.",
      "name": "Spirituosenherstellung "
    },
    {
      "code": "0137",
      "shortname": "Sportartikelh.",
      "name": "Sportartikelherstellung"
    },
    {
      "code": "0138",
      "shortname": "Fitnessstudio",
      "name": "Sportstudio / Fitnessstudio"
    },
    {
      "code": "0139",
      "shortname": "Steuerberater",
      "name": "Steuerberater"
    },
    {
      "code": "0140",
      "shortname": "Straßenbau",
      "name": "Straßenbau"
    },
    {
      "code": "0141",
      "shortname": "Tabakwarenherst",
      "name": "Tabakwarenherstellung"
    },
    {
      "code": "0142",
      "shortname": "Tankstellen",
      "name": "Tankstellen"
    },
    {
      "code": "0143",
      "shortname": "Tanzschule",
      "name": "Tanzschule"
    },
    {
      "code": "0144",
      "shortname": "Tattoo-Studio",
      "name": "Tattoo-Studio"
    },
    {
      "code": "0145",
      "shortname": "Taxiunternehmen",
      "name": "Taxiunternehmen"
    },
    {
      "code": "0146",
      "shortname": "Teigwarenherst.",
      "name": "Teigwarenherstellung"
    },
    {
      "code": "9003",
      "shortname": "Testzentrum",
      "name": "Testzentrum"
    },
    {
      "code": "0147",
      "shortname": "Textilherst.",
      "name": "Textilherstellung und -verarbeitung"
    },
    {
      "code": "0148",
      "shortname": "Tierzucht",
      "name": "Tierzucht"
    },
    {
      "code": "0149",
      "shortname": "Transportuntern",
      "name": "Transportbetriebe"
    },
    {
      "code": "0150",
      "shortname": "Unternehmensber",
      "name": "Unternehmensberatung / Consulting"
    },
    {
      "code": "0151",
      "shortname": "Verein (Profis)",
      "name": "Vereine mit Profi- und Lizensportler"
    },
    {
      "code": "0152",
      "shortname": "Verlag",
      "name": "Verlag"
    },
    {
      "code": "0153",
      "shortname": "Verpackungsbetr",
      "name": "Verpackungsbetrieb"
    },
    {
      "code": "0154",
      "shortname": "Versicherungsv.",
      "name": "Versicherungsvermittlung"
    },
    {
      "code": "0155",
      "shortname": "Security-Untern",
      "name": "Wach- und Schließgesellschaften"
    },
    {
      "code": "0156",
      "shortname": "Wäscherei",
      "name": "Wäscherei"
    },
    {
      "code": "0157",
      "shortname": "Wasserkraftwerk",
      "name": "Wasserkraftwerke"
    },
    {
      "code": "0158",
      "shortname": "Weinkellerei",
      "name": "Wein- und Sektkellerei"
    },
    {
      "code": "0159",
      "shortname": "Werbeagentur",
      "name": "Werbeagentur"
    },
    {
      "code": "0160",
      "shortname": "Werkzeugbau",
      "name": "Werkzeugbau"
    },
    {
      "code": "0161",
      "shortname": "Wettbüros",
      "name": "Wettbüros"
    },
    {
      "code": "0162",
      "shortname": "Windkraftwerke",
      "name": "Windkraftwerke"
    },
    {
      "code": "0163",
      "shortname": "Wirtschaftspr.",
      "name": "Wirtschaftsprüfer"
    },
    {
      "code": "0164",
      "shortname": "Wohnungsbaugen.",
      "name": "Wohnungsbaugenossenschaften"
    },
    {
      "code": "0165",
      "shortname": "Zeitarbeit",
      "name": "Zeitarbeitsfirmen"
    },
    {
      "code": "0166",
      "shortname": "Zimmerei ",
      "name": "Zimmerei und Holzbau"
    }
  ],
  "exclusions": [
    {
      "code": "0001",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0002",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0003",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0005",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0007",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0009",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0010",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0011",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0013",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0014",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0018",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0019",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0020",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0026",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0027",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0028",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 0,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0029",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0031",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0032",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0033",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0039",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0040",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0041",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0042",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0045",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0050",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0051",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0053",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0056",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0061",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0068",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0069",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0074",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0077",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0080",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0083",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0085",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0086",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0088",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0090",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0091",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0093",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0097",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0102",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0103",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0105",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0106",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0107",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0109",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0110",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0111",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0113",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0114",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0115",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0116",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0117",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0119",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0120",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 0,
      "KEINFIRMA": 0,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 1
    },
    {
      "code": "0122",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0123",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0124",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0125",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0126",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0127",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0128",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0130",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 0,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0132",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0133",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0134",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0139",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0142",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0144",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 0,
      "KEINFIRMA": 0,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 1
    },
    {
      "code": "0145",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0149",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0150",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0151",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0155",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0156",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 0,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0157",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0161",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0162",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0163",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0164",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "0165",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "0168",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 0,
      "KEINSSR": 0
    },
    {
      "code": "9001",
      "KEINVERKEHR": 0,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "9002",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
    {
      "code": "9003",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },{
      "code": "9004",
      "KEINVERKEHR": 1,
      "KEINKOMPEX": 1,
      "KEINFIRMA": 1,
      "KEINIMMOBILIEN": 1,
      "KEINSSR": 0
    },
  ],

  branchenList: function () {
    let sonstige = this.branchen.find(b => b.code === '0000');
    sonstige.name = '-- Sonstige Branche --';
    let sortedBranchen = this.branchen.filter(b => b.code !== '0000').map(b => {
      return {
        code: b.code,
        name: b.name
      };
    }).sort((a, b) => a.name.localeCompare(b.name));
    return [sonstige].concat(sortedBranchen);
  }
};
